module.exports = __webpack_public_path__ + "img/order.a48b88ed.png";